// extracted by mini-css-extract-plugin
module.exports = {"latestPhones":"phoneslider_latestPhones__1YeI2","phone":"phoneslider_phone__1qDKX","title":"phoneslider_title__3nuMV"};